import { Box, FormLabel, makeStyles, Switch } from '@material-ui/core';

import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { PricingFilterType } from '@/components/widgets/LoanDetailActions/components/LoanDetailActionsDialog/components/ChangeLoanConditionsDialog/types/PricingFilterType';

interface PricingFiltersProps {
  filters: PricingFilterType[];
  setFilters: React.Dispatch<React.SetStateAction<PricingFilterType[]>>;
}

export const PRICING_FILTERS_VALUES = [PricingFilterType.PROGRAM];

export const PricingFilters = ({ filters, setFilters }: PricingFiltersProps) => {
  const onChangeFilters = (event, value) => {
    const isFilterSet = !value;
    setFilters((s) => {
      if (isFilterSet) {
        return [...s, event.target.name];
      } else {
        return [...s].filter((item) => item !== event.target.name);
      }
    });
  };

  const useStyles = makeStyles({
    root: {
      top: 0,
      left: 0,
      '& .MuiSwitch-track': {
        height: '12px',
        top: '0',
      },
    },
  });

  const classes = useStyles();

  return (
    <Box display={'flex'} flexDirection={'row'} gridGap={12} justifyContent={'space-between'}>
      <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
        {filters.length > 0 && (
          <Font variant="caption" color="textSecondary">
            <Text tId={'PRICINGS_ARE_FILTERED_BY_LOAN_CONDITIONS'} />
          </Font>
        )}
      </Box>
      <Box display={'flex'} flexDirection={'row'} justifyContent={'flex-end'} minWidth={'35%'}>
        {PRICING_FILTERS_VALUES.map((filter) => (
          <Box display={'flex'} flexDirection={'row'} alignItems={'center'} key={filter} gridGap={4}>
            <Switch
              className={classes.root}
              size="small"
              color={'secondary'}
              key={filter}
              name={filter}
              onChange={onChangeFilters}
            />
            <FormLabel>
              <Font variant="caption">
                <Text tId={`all_${filter}`} />
              </Font>
            </FormLabel>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
